// extracted by mini-css-extract-plugin
module.exports = {"logo":"styles-module--logo--3WU3C","image":"styles-module--image--miASs"};